export const TRANSACTION_STATES = Object.freeze({
  PROCESSING: 'Processing',
  CONFIRMATION: 'Confirmation',
  PAID: 'Paid',
  ERROR: 'Error'
});



// WEBPACK FOOTER //
// ./src/constants/transaction.js